import React from 'react';
import {AiOutlineCheckCircle, AiOutlineCloseCircle} from "react-icons/ai";

export function AIFeedback({totalPoints, maxPoints, feedback, show}) {

    if(!show) return null;

    return (
        <div className={"p-3 px-4 border-bottom"} style={{backgroundColor:(totalPoints === maxPoints ? "#e6f4ea":"#fff3f2")}} >

            <div className={"d-flex mb-2"}>
                {
                    totalPoints === maxPoints ?
                        <AiOutlineCheckCircle size={24} className={" text-success me-2"}/>
                        :
                        <AiOutlineCloseCircle size={24} className={" text-danger me-2"}/>
                }
                <p className={"p-0 m-0 fw-bold"}>Tilbakemelding</p>
            </div>
            <p className={""}>{feedback}</p>
        </div>
    );

}